import { createSlice } from "@reduxjs/toolkit";
import {
  fetchPayrollCohorts,
  fetchPayrollCohortById,
  createPayrollCohort,
  updatePayrollCohort,
  deletePayrollCohort,
} from "../thunks/payrollCohortThunk";

const initialState = {
  payrollCohorts: [],
  selectedPayrollCohort: null,
  loading: false,
  error: null,
};

const payrollCohortSlice = createSlice({
  name: "payrollCohorts",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedPayrollCohort: (state) => {
      state.selectedPayrollCohort = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all payroll cohorts
      .addCase(fetchPayrollCohorts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPayrollCohorts.fulfilled, (state, action) => {
        state.loading = false;
        state.payrollCohorts = action.payload;
      })
      .addCase(fetchPayrollCohorts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch payroll cohort by ID
      .addCase(fetchPayrollCohortById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPayrollCohortById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedPayrollCohort = action.payload;
      })
      .addCase(fetchPayrollCohortById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create payroll cohort
      .addCase(createPayrollCohort.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPayrollCohort.fulfilled, (state, action) => {
        state.loading = false;
        state.payrollCohorts.push(action.payload);
      })
      .addCase(createPayrollCohort.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update payroll cohort
      .addCase(updatePayrollCohort.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePayrollCohort.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.payrollCohorts.findIndex(
          (cohort) => cohort._id === action.payload._id
        );
        if (index !== -1) {
          state.payrollCohorts[index] = action.payload;
        }
        if (state.selectedPayrollCohort?._id === action.payload._id) {
          state.selectedPayrollCohort = action.payload;
        }
      })
      .addCase(updatePayrollCohort.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete payroll cohort
      .addCase(deletePayrollCohort.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePayrollCohort.fulfilled, (state, action) => {
        state.loading = false;
        state.payrollCohorts = state.payrollCohorts.filter(
          (cohort) => cohort._id !== action.payload
        );
        if (state.selectedPayrollCohort?._id === action.payload) {
          state.selectedPayrollCohort = null;
        }
      })
      .addCase(deletePayrollCohort.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearSelectedPayrollCohort } = payrollCohortSlice.actions;
export default payrollCohortSlice.reducer;